import React, { useEffect, useMemo, useState } from "react";
import "../styles/AccountClosureReport.css";
import axios from "axios";
import { toast } from "react-toastify";

export default function AccountClosureReport() {
  const [filters, setFilters] = useState({
    accountType: "",
    fromDate: "",
    toDate: "",
    accountNumber: "",
  });
  const [activeTab, setActiveTab] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const [showModal, setShowModal] = useState(false);
  const [selectedBenefit, setSelectedBenefit] = useState(null);
  const [savingReport,setSavingReport]=useState([]);
  const [accountsData, setAccountsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [formData, setFormData] = useState({
        loancloserremark: "",
      });
  

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(filters);
  };

  const openModal = (benefitData) => {
    setSelectedBenefit(benefitData);
    setShowModal(true);
  };

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedBenefit(null);
  };
 
 const fetchAccounts = async () => {
     try {
       setLoading(true);
       setError("");
 
       const superAdminId = localStorage.getItem("adminuserId") || 14;
 
       const response = await axios.get(
         "https://payyug.in/api/get-all-saving-account",
         { params: { superAdminId } }
       );
 
       if (Array.isArray(response.data.accounts)) {
         setAccountsData(response.data.accounts);
       } else {
         setAccountsData([]);
       }
     } catch (err) {
       console.error("Error fetching saving accounts:", err);
       setError("Failed to load saving accounts.");
     } finally {
       setLoading(false);
     }
   };
 
   useEffect(() => {
     fetchAccounts();
   }, []);

   const verifyAccountCloser = async (e,item) => {
     e.preventDefault();
      const isConfirmed = window.confirm(
        "Are you sure you want to close this account?"
      );

      if (!isConfirmed) return; 
     try {
       const response = await axios.put(
         `https://payyug.in/api/close-saving-account/closed/${item?.id}`
       );
   
       toast.success("saving account closure verified successfully!");
       setShowModal(false);
       fetchAccounts();
       return response.data;
     } catch (error) {
       const msg =
         error?.response?.data?.message ||
         "Something went wrong while verifying saving account closure request.";
   
       toast.error(msg);
       console.error("Error in verifying saving account closure request.", msg);
       return null;
     }
   };
  
  // const filteredData=accountsData;
  const filteredData = useMemo(() => {
      let data = [...accountsData];
      if (activeTab !== "All") data = data.filter((item) => item.status === activeTab);
      data = data.filter((item) => item.status === "CloseRequested");
      return data;
    }, [accountsData, activeTab]);


  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const paginatedData =
    activeTab === "All"
      ? filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
      : filteredData;


  

  return (
    <div className="AccountClosureReport">
      {/* FILTER SECTION */}
      {/* <section className="AccountClosureReport-filter-section">
        <h2>Account Report Filter</h2>
        <p>Use filter to see more precised report</p>
        <form onSubmit={handleSubmit} className="AccountClosureReport-filter-form">
          <div className="AccountClosureReport-form-group">
            <label>Choose Account Type</label>
            <select name="accountType" value={filters.accountType} onChange={handleChange}>
              <option value="">Select account type</option>
              <option value="RD">Recurring Deposit</option>
              <option value="DD">Daily Deposit</option>
              <option value="SAV">Saving Account</option>
            </select>
          </div>

          <div className="AccountClosureReport-form-group">
            <label>From Date</label>
            <input type="date" name="fromDate" value={filters.fromDate} onChange={handleChange} />
          </div>

          <div className="AccountClosureReport-form-group">
            <label>To Date</label>
            <input type="date" name="toDate" value={filters.toDate} onChange={handleChange} />
          </div>

          <div className="AccountClosureReport-form-group">
            <label>Account Number</label>
            <input type="text" name="accountNumber" value={filters.accountNumber} onChange={handleChange} placeholder="Enter account number" />
          </div>

          <button type="submit" className="AccountClosureReport-filter-button">Submit</button>
        </form>
      </section> */}

      {/* REPORT SECTION */}
      <section className="AccountClosureReport-report-section">
        <h2>Saving Account Closer Report</h2>
        <div className="AccountClosureReport-report-controls">
          <label>
            Search:
            <input type="text" placeholder="Search..." />
          </label>
          <label>
            Show
            <select>
              <option>10</option>
              <option>25</option>
              <option>50</option>
            </select>
            entries
          </label>
        </div>

        <div className="AccountClosureReport-table-responsive">
          <table className="AccountClosureReport-table">
            <thead>
             <tr>
              <th>SN</th>
              <th>Account No</th>
              <th>Customer Name</th>
              <th>Account Type</th>
              <th>Status</th>
              <th>Opened Date</th>
              <th>Opening Balance</th>
              <th>Current Balance</th>
              <th>Refer ID</th>
              <th>Nominee ID</th>
              <th>Action</th>
            </tr>
            </thead>
             <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((item, index) => (
                <tr key={item.id}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{item.accountNumber || "NA"}</td>
                  <td>{item.customerName || "NA"}</td>
                  <td>{item.accountType || "NA"}</td>
                  <td>{item.status || "NA"}</td>
                  <td>{item.openedDate?.split("T")[0] || "NA"}</td>
                  <td>₹{item.openingBalance || "0"}</td>
                  <td>₹{item.currentBalance || "0"}</td>
                  <td>{item.referId || "NA"}</td>
                  <td>{item.nomineeId || "NA"}</td>

                  {/* FIXED: Action Column */}
                  <td>
                    <button
                      onClick={(e) => verifyAccountCloser(e, item)}
                      disabled={item.status === "Closed"}
                    >
                      {item.status === "Closed" ? "Closed" : "Close"}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" style={{ textAlign: "center" }}>
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
          </table>
        </div>
      </section>

      {/* MODAL */}
      {/* {showModal && selectedBenefit && (
        <div className="AccountClosureReport-modal-backdrop" onClick={closeModal}>
          <div className="AccountClosureReport-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Benefit Details</h3>
            <table className="AccountClosureReport-benefit-table">
              <tbody>
                {Object.entries(selectedBenefit).map(([key, value]) => (
                  <tr key={key}>
                    <td className="key">{key.replace(/([A-Z])/g, ' $1')}</td>
                    <td className="value">{value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <button onClick={closeModal} className="AccountClosureReport-close-btn">Close</button>
          </div>
        </div>
      )} */}

       {/* {showModal && (
          <div className="dialog-overlay">
            <div className="dialog-box">
              <h2 className="dialog-box-heading">
                {"Verify Loan"}
              </h2>

              <form className="dialog-box-form-section" onSubmit={verifyAccountCloser}>
                <div className="dialog-box-input-group">
                  <label>Loan Closure Remark</label>
                   <input
                    type="text"
                    name="loancloserremark"
                    value={formData.loancloserremark}
                    onChange={handleChange1}
                  />
                </div>

                <div className="dialog-btns">
                  <button type="submit">
                    {"Verify"}
                  </button>

                  <button type="button" onClick={() => setShowModal(false)}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )} */}


       {activeTab === "All" && filteredData.length > rowsPerPage && (
        <div className="SR-pagination">
          <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>
            ⬅ Prev
          </button>
          <span>Page {currentPage} of {totalPages}</span>
          <button
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next ➡
          </button>
        </div>
      )}
    </div>
  );
}
